import { Component, OnInit } from '@angular/core';
import { DimeloService } from '../../shared/services/dimelo.service';
import { ConstsHelper } from '../../../helpers/consts.helper';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirection',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.css'],
  standalone: false
})
export class RedirectionComponent implements OnInit {

  environment = environment;
  constructor(private dimeloService: DimeloService, private router: Router) {}

  ngOnInit() {
    const callbackStorage = JSON.parse(localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CALLBACK));
    this.dimeloService.get().subscribe( response => {
      localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_CALLBACK);
      if (this.environment.data.assistanceUrl !== callbackStorage.callback) {
        if (callbackStorage.callback.includes('assistance.prixtel') || callbackStorage.callback.includes('assistance-prixtel')) {
          window.open(this.environment.data.assistanceUrl, '_self');
        } else {
          window.open(callbackStorage.callback, '_self');
        }
        return;
      } else {
        window.open(this.environment.data.assistanceUrl, '_self');
      }
    });
    this.router.navigate(['/lignes']);
  }
}
